import { useState } from "react";
import type { QuizQuestion } from "../lib/types";

interface Props {
  questions: QuizQuestion[];
  onScored?: (score: number) => void;
}

export function Quiz({ questions, onScored }: Props) {
  const [answers, setAnswers] = useState<Record<number, number>>({});

  function pick(qIdx: number, optIdx: number) {
    if (answers[qIdx] !== undefined) return;
    const next = { ...answers, [qIdx]: optIdx };
    setAnswers(next);
    if (Object.keys(next).length === questions.length && onScored) {
      const score =
        questions.reduce(
          (s, q, i) => s + (q.options[next[i]].correct ? 1 : 0),
          0,
        ) / questions.length;
      onScored(score);
    }
  }

  return (
    <div className="gf-quiz">
      {questions.map((q, qIdx) => {
        const picked = answers[qIdx];
        const isAnswered = picked !== undefined;
        const isCorrect = isAnswered && q.options[picked].correct;
        return (
          <div key={qIdx}>
            <h4 className="gf-quiz__q">
              {qIdx + 1}. {q.q}
            </h4>
            <div className="gf-quiz__options">
              {q.options.map((opt, oi) => {
                const cls = ["gf-quiz__option"];
                if (isAnswered) {
                  if (oi === picked) cls.push("is-selected");
                  if (oi === picked && opt.correct) cls.push("is-correct");
                  if (oi === picked && !opt.correct) cls.push("is-wrong");
                  if (oi !== picked && opt.correct) cls.push("is-correct");
                }
                return (
                  <button
                    key={oi}
                    className={cls.join(" ")}
                    onClick={() => pick(qIdx, oi)}
                    disabled={isAnswered}
                  >
                    <div className="gf-quiz__option-radio"></div>
                    <div>{opt.t}</div>
                  </button>
                );
              })}
            </div>
            {isAnswered && (
              <div
                className={`gf-quiz__feedback gf-quiz__feedback--${isCorrect ? "ok" : "no"}`}
              >
                {isCorrect ? q.why : q.wrongWhy}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
